import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';

new Vue({
    el: '#resource-listing',
    delimiters: ['${', '}'],
    data: {
        resources: [],
        resourceTypes: [],
        content: [],
        product: '',
        industry: '',
        solution: '',
        type: '',
        page: 1,
        total: 0,
        loading: false,
        filtering: false,
        perPage: 12,
        featured: false,
        siteUrl: '',
        resourcesUrl: '',
        filtered: false
    },
    computed: {
        hasResourceTypes() {
            return this.resourceTypes.length != 0;
        },
        hasResources() {
            return this.resources.length != 0 || this.featuredTypes.length != 0 || this.unfeaturedTypes.length != 0;
        },
        showLoadMore() {
            return this.hasResources && (this.loading || (this.page * this.perPage) < this.total);
        },
        noResults() {
            return !this.hasResources && !this.hasResourceTypes;
        },
        showByType() {
            return this.hasResourceTypes;
        },
        featuredTypes() {
            return this.resourceTypes.filter( type => type.featured && type.resources.length );
        },
        unfeaturedTypes() {
            return this.resourceTypes.filter( type => !type.featured && type.resources.length );
        },
    },
    methods: {
        clearFilters() {
            this.product = '';
            this.industry = '';
            this.solution = '';
            this.type = '';
            this.filter();
        },
        iconClass(icon) {
            return `fal fa-${icon} iconCardFilters__icon`;
        },
        loadMore() {
            this.page++;
            this.loading = true;
            this.pullContent(true);
        },
        filter() {
            this.page = 1;
            this.total = 0;
            this.filtering = true;
            this.pullContent();
            this.updateUrl();
        },
        checkFiltered() {
            this.filtered = Boolean(this.product || this.solution || this.industry || this.type);
        },
        updateResources() {
            this.resources = [];
            this.resourceTypes = [];

            let params = {
                pr: this.product,
                s: this.solution,
                i: this.industry,
                t: this.type,
                perPage: this.perPage,
                page: this.page,
            };

            if (this.type != '') {
                return axios({
                    method: 'get',
                    url: this.siteUrl + 'actions/mclanahan/mclanahan/filtered-resources',
                    params: params
                }).then(response => {
                    let data = response.data;

                    this.resources = data.resources;
                    this.chunkContent();
                    this.total = data.total;
                }).catch(error => {});
            } else {
                return axios({
                    method: 'get',
                    url: this.siteUrl + 'actions/mclanahan/mclanahan/filtered-resources-by-type',
                    params: params
                }).then(response => {
                    let data = response.data;

                    this.resourceTypes = data.resourceTypes;
                    this.total = data.total;
                }).catch(error => {});
            }
        },
        pullContent() {
            Promise.all([
                this.updateResources(),
            ]).then(() => {
                this.finishLoading();
            });
        },
        updateUrl() {
            let resourcesUrl = this.resourcesUrl;
            let filters = [];

            if (this.type) {
                resourcesUrl += '/' + this.type;
            }
            if (this.product) {
                filters['pr'] = this.product;
            }
            if (this.industry) {
                filters['i'] = this.industry;
            }
            if (this.solution) {
                filters['s'] = this.solution;
            }

            if (Object.keys(filters).length) {
                let queryString = Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
                resourcesUrl += '?' + queryString;
            }

            if (window.history.replaceState) {
                window.history.replaceState(
                    {}, document.title, `/${resourcesUrl}`
                );
            }
        },
        chunkContent() {
            if (this.page > 1) {
                this.content = this.content.concat(this.resources);
            } else {
                this.content = this.resources;
            }
        },
        finishLoading() {
            this.checkFiltered();
            this.loadSlick();

            this.loading = false;
            this.filtering = false;
        },
        loadSlick() {
            // Initialize Slick sliders here
            this.$nextTick(() => {
                // Ensure that Vue has updated the DOM before initializing sliders
                $(".js-imageCardSlider").each((index, element) => {
                    $(element).slick({
                    arrows: true,
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    draggable: false,
                    prevArrow: $(element)
                        .parents(".imageCardSlider")
                        .find(".imageCardSlider__arrow.-prev"),
                    nextArrow: $(element)
                        .parents(".imageCardSlider")
                        .find(".imageCardSlider__arrow.-next"),
                    responsive: [
                        {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                        },
                        {
                            breakpoint: 950,
                            settings: {
                            slidesToShow: 2,
                            }
                        }
                    ]
                    });
                });



                $(".js-iconCardFilters").each((index, element) => {
                    const cardCount = $(element).find(".iconCardFilters__card").length;
                    const sliderContainer = $(element).parents(".iconCardFilters");

                    if (cardCount > 6) {
                    // if there are more than 6 .iconCardFilters__cards, initialize a slick slider
                    sliderContainer.addClass("-slider");

                    $(element).slick({
                        arrows: true,
                        infinite: true,
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        prevArrow: $(element)
                        .parents(".iconCardFilters")
                        .find(".iconCardFilters__arrow.-prev"),
                        nextArrow: $(element)
                        .parents(".iconCardFilters")
                        .find(".iconCardFilters__arrow.-next"),
                        responsive: [
                        {
                            breakpoint: 950,
                            settings: {
                                slidesToShow: 5,
                            }
                        },
                        {
                            breakpoint: 810,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                        ]
                    });
                    }
                });
            });
        }
    },
    mounted() {
        if (useResourceTypes) {
            this.resourceTypes = initialResources.resourceTypes;
        } else {
            this.resources = initialResources.resources;
            this.chunkContent();
        }
        this.total = initialResources.total;
        this.siteUrl = document.body.getAttribute('data-site-url');
        this.resourcesUrl = this.$el.getAttribute('data-page-url');

        this.product = product;
        this.solution = solution;
        this.industry = industry;
        this.type = type;

        this.checkFiltered();
        this.finishLoading();

        this.$el.classList.remove('hidden-on-load');

        if (this.filtered) {
            $('html, body').animate({
                scrollTop: 200
            }, 1000);
        }
    }
});